import React from 'react';

const About = () => {
    return (
        <div name="about" className="w-full h-screen bg-gradient-to-b
                    from-gray-800 to-black text-white">
            <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
                <div className="pb-8">
                    <p className="text-4xl font-bold inline border-b-4 border-gray-500">About</p>
                </div>

                <p className="text-xl mt-20">
                    My name is Devashish Biswas. I am from Rudrapur Uttarakhand. I have done my schooling from Uttakhand board & then I pursued B.tech in Electronics & Communication from APJ. Abdul Kalam Technical University Lucknow.
                    Being a B.tech graduate in ECE and working in a corporate office it's been very tough to get into programming & not only I learnt programming, I have learnt it without enrolling in a certification.Talking about my
                    journey till today itself I have completed two full stack projects & it's working perfectly fine, after so many attempts . It feels great. Really really great.
                    
                    i am sharing my portfolio link here to check it from github code
        
                    https://clever-granita-cfabd0.netlify.app/
                                    
                </p>

                <br />

                <p className="text-xl">
                    Let's talk about my learning <br />
                    While learning programming there were so many challenges, from where I have to start and where I have to end. I started to learn lot of things.At first I started to learn HTML then CSS & then JavaScript. while working at office
                    I used to open multi window to read tutorials in spare time. I just don't want to be fail and not to think by the recruiters that he is from non CS background & he must be a little knowledge , therefore I started to learn
                    all the major language's core concepts like Java ,JavaScript , C, C++, C#, Python, Typescript, PHP, then frameworks like Django, Angular, React Js, BootStrap, TailwindCSS , Node Js, Express Js, Laravel, Spring Boot &
                    also go through the tutorial for GIT & GitHub.Be familiar also with databases like mySql , MongoDb. It's been around 9 months I am learning I also faced so many failure while making project because taking tutorials and
                    reading theory is different thing and making projects is different thing. I almost 9-10 times failed in making project & it's been so much demotivating after so much effort and time if project gets failed. But I did not
                    give up. Finally I have been succeed and able to successfully completed 2 Full Stack Projects.It's awesome!!! & belive me it took lots of efforts, hard work & patience.. At present I am very happy at this stage of gaining
                    skills and I have firm belive that this portfolio is going to be much much bigger in upcoming days...
                </p>
            </div>


        </div>
    )
}

export default About
